import { styled as muiStyled } from '@mui/material'

export const ScheduledPatientDatePickerContainer = muiStyled('div')(
  ({ theme }) => `
    .react-daterange-picker__wrapper {
    border: unset;
    background: #ebebeb;
    border-radius: 7px;
    padding: 8px;}
`,
)
